// @flow
import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  SHOW_RIGHT_SIDEBAR,
  CHANGE_SIDEBAR_THEME_IMAGE,
  CHANGE_PRELOADER,
  TOGGLE_LEFTMENU,
  SHOW_SIDEBAR,
  CHANGE_LAYOUT_MODE
} from "./actionTypes";

//constants
import {
  layoutTypes,
  layoutModeTypes,
  layoutWidthTypes,
  topBarThemeTypes,
  leftBarThemeImageTypes,
  leftSidebarTypes,
  leftSideBarThemeTypes,
} from "../../constants/layout";

const INIT_STATE = {
  layoutType: layoutTypes.VERTICAL,
  layoutModeType: layoutModeTypes.LIGHT,
  layoutWidth: layoutWidthTypes.FLUID,
  leftSideBarTheme: leftSideBarThemeTypes.DARK,
  leftSideBarThemeImage: leftBarThemeImageTypes.NONE,
  leftSideBarType: leftSidebarTypes.DEFAULT,
  topbarTheme: topBarThemeTypes.LIGHT,
  isPreloader: false,
  showRightSidebar: false,
  isMobile: false,
  showSidebar: true,
  leftMenu: false,
}

const Layout = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_LAYOUT:
      if (state.layoutType !== action.payload) {
        return {
          ...state,
          layoutType: action.payload,
        }
      }
      break;
      
    case CHANGE_PRELOADER:
      if (state.isPreloader !== action.payload) {
        return {
          ...state,
          isPreloader: action.payload,
        }
      }
      break;
      
    case CHANGE_LAYOUT_MODE:
      if (state.layoutModeType !== action.payload) {
        return {
          ...state,
          layoutModeType: action.payload,
        }
      }
      break;

    case CHANGE_LAYOUT_WIDTH:
      if (state.layoutWidth !== action.payload) {
        return {
          ...state,
          layoutWidth: action.payload,
        }
      }
      break;

    case CHANGE_SIDEBAR_THEME:
      if (state.leftSideBarTheme !== action.payload) {
        return {
          ...state,
          leftSideBarTheme: action.payload,
        }
      }
      break;

    case CHANGE_SIDEBAR_THEME_IMAGE:
      if (state.leftSideBarThemeImage !== action.payload) {
        return {
          ...state,
          leftSideBarThemeImage: action.payload,
        }
      }
      break;

    case CHANGE_SIDEBAR_TYPE:
      if (state.leftSideBarType !== action.payload.sidebarType) {
        return {
          ...state,
          leftSideBarType: action.payload.sidebarType,
        }
      }
      break;

    case CHANGE_TOPBAR_THEME:
      if (state.topbarTheme !== action.payload) {
        return {
          ...state,
          topbarTheme: action.payload,
        }
      }
      break;

    case SHOW_RIGHT_SIDEBAR:
      if (state.showRightSidebar !== action.payload) {
        return {
          ...state,
          showRightSidebar: action.payload,
        }
      }
      break;

    case SHOW_SIDEBAR:
      if (state.showSidebar !== action.payload) {
        return {
          ...state,
          showSidebar: action.payload,
        }
      }
      break;

    case TOGGLE_LEFTMENU:
      if (state.leftMenu !== action.payload) {
        return {
          ...state,
          leftMenu: action.payload,
        }
      }
      break;

    default:
      break;
  }
  
  return state;
}

export default Layout
